<template>
  <div class="announcement">
    <div class="header_whole">
      <div class="title">
        <span>平台公告</span>
      </div>
      <div class="bottom">PLATFORM ANNOUNCEMENT</div>
      <div class="view_more" @click="viewMore">查看更多</div>
    </div>
    <div class="swiper_content">
      <!-- <ElBlockSkeleton height="66.5vh" margin="1vw 0 1vw 0" :loading="skeletonLoading"><AntEmpty v-show="!data.length" /></ElBlockSkeleton> -->

      <AntPolySkeleton height="3rem" :num="8" :rows="1" margin="0.3rem 0" :loading="skeletonLoading">
        <AntEmpty v-show="!data.length" />
      </AntPolySkeleton>
      <swiper class="swiper" :options="option" :key="key" @mouseover.native="mouseover" @mouseout.native="mouseout">
        <swiper-slide :class="`swiper_slide`" v-for="(item,index) in data" :key="index">
          <div class="whole" @click="submit(item)">
            <div class="tag_title">
              <span class="tag">NEW</span>
              <span class="title">{{item.title}}</span>
            </div>
          </div>
        </swiper-slide>
      </swiper>
    </div>
  </div>
</template>

<script>
let livingExample = null; //swiper实例
let that = null;
export default {
  data() {
    return {
      key: 0,
      skeletonLoading: true,
      data: [],
      cancells: this.$FN.cancells(),
      option: {}
    }
  },
  created() {
    this.setOption();
    this.getData();
  },
  methods: {
    viewMore() {
      this.$FN.limitsTips({ list: ["home_announcement_list"] }).then(res => {
        if (res) {
          this.$router.push('/message');
          // this.$router.$push({ path: 'container', query: { url: `${this.$FN.iframeUrl}/page/artview?switchnum=5` } });
        } else {
          this.$FN.Tips(false)
        }
      });
    },
    submit(data) {
      this.$FN.limitsTips({ list: ["home_announcement_details"] }).then(res => {
        if (res) {
          this.$router.push('/message');
          // this.$router.$push({ path: 'container', query: { url: `${this.$FN.iframeUrl}/npg/artview/detail?docId=${data.id}` } });
        }
      });
    },
    mouseover() { livingExample.autoplay.stop() },
    mouseout() { livingExample.autoplay.start() },
    setOption() {
      this.option = {
        pagination: '.swiper-pagination',
        direction: "vertical",
        autoplay: {
          delay: 2000,
          stopOnLastSlide: false,
          disableOnInteraction: true,
        },
        slidesPerView: 9,
        initialSlide: 0,
        autoHeight: true,
        spend: 300,
        preventClicks: false,
        on: {
          init: function () { livingExample = this },
          slideChange: function () {
            // console.log(this.activeIndex, "this.activeIndex");
            // 由于this没有指向vue实例,所以需要activeIndex中转一下
            // that.activeIndex.index = this.activeIndex;
            // let { path = '' } = that.headerList[this.activeIndex];
            // if (path) that.form.moduleId = path;
            // that.getData();
          }
        }
      };
    },
    getData() {
      let config = { method: "post" };
      this.cancells("api/product_service/art_manage/get_docs", {}, config).then(res => {
        this.skeletonLoading = false;
        if (res) {
          let { entity = {} } = res;
          this.data = entity.list || [];
          this.key = Math.random();
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
@import url("./index.less");
</style>